import { Address } from 'viem';

export const strETHTokenAddress: Address = '0xcd3c0F51798D1daA92Fb192E57844Ae6cEE8a6c7';
